import React from 'react';
import { UsersIcon, PresentationIcon, BriefcaseIcon, HandshakeIcon, CheckIcon } from 'lucide-react';
export function MeetingGoalDefinition({
  data,
  updateData
}) {
  const meetingGoals = [{
    id: 'client-calls',
    title: 'Client Calls',
    icon: <UsersIcon className="h-5 w-5" data-id="element-705" />,
    description: 'Be better prepared for meetings with clients and prospects'
  }, {
    id: 'internal-meetings',
    title: 'Internal Strategy Meetings',
    icon: <BriefcaseIcon className="h-5 w-5" data-id="element-706" />,
    description: 'Get insights for team meetings and internal discussions'
  }, {
    id: 'sales-pitches',
    title: 'Sales Pitches',
    icon: <PresentationIcon className="h-5 w-5" data-id="element-707" />,
    description: 'Optimize your sales presentations and demos'
  }, {
    id: 'investor-meetings',
    title: 'Investor/Partner Meetings',
    icon: <HandshakeIcon className="h-5 w-5" data-id="element-708" />,
    description: 'Prepare for meetings with investors, partners, and stakeholders'
  }];
  const toggleGoal = goalId => {
    const currentGoals = [...data.meetingGoals];
    if (currentGoals.includes(goalId)) {
      updateData('meetingGoals', currentGoals.filter(id => id !== goalId));
    } else {
      updateData('meetingGoals', [...currentGoals, goalId]);
    }
  };
  return <div data-id="element-709">
      <h2 className="text-2xl font-bold mb-2" data-id="element-710">Meeting Goals</h2>
      <p className="text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-711">
        I want to be better prepared for... (select all that apply)
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-712">
        {meetingGoals.map(goal => <div key={goal.id} onClick={() => toggleGoal(goal.id)} className={`flex items-start p-4 border rounded-lg cursor-pointer transition-all ${data.meetingGoals.includes(goal.id) ? 'border-[#C8F169] bg-[#C8F169] bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 hover:border-[#F5F7FA] hover:border-opacity-30'}`} data-id="element-713">
            <div className={`p-2 rounded-lg mr-3 ${data.meetingGoals.includes(goal.id) ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'bg-[#F5F7FA] bg-opacity-10 text-[#F5F7FA]'}`} data-id="element-714">
              {goal.icon}
            </div>
            <div className="flex-1" data-id="element-715">
              <h3 className="font-medium" data-id="element-716">{goal.title}</h3>
              <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-717">
                {goal.description}
              </p>
            </div>
            <div className={`ml-3 h-5 w-5 rounded flex-shrink-0 flex items-center justify-center ${data.meetingGoals.includes(goal.id) ? 'bg-[#C8F169] text-[#1E2A38]' : 'border border-[#F5F7FA] border-opacity-30'}`} data-id="element-718">
              {data.meetingGoals.includes(goal.id) && <CheckIcon className="h-3 w-3" data-id="element-719" />}
            </div>
          </div>)}
      </div>
      <div className="mt-6 bg-[#1E2A38] border border-[#F5F7FA] border-opacity-10 rounded-lg p-4" data-id="element-720">
        <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-721">
          Your selection helps us prioritize the most relevant information in
          your meeting briefs. You can always adjust these preferences later in
          your settings.
        </p>
      </div>
    </div>;
}